exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "svg[data-v-39e5550d]{width:48%;margin-top:13.5%;margin-left:9.5%}.st0[data-v-39e5550d],.st1[data-v-39e5550d]{fill:none;stroke:#fff;stroke-width:1.5;stroke-miterlimit:10}.st1[data-v-39e5550d]{stroke-dasharray:1.9893,1.9893}.st2[data-v-39e5550d]{fill:none;stroke:#fff;stroke-width:1.5;stroke-miterlimit:10;stroke-dasharray:2}@media only screen and (max-width:737px){svg[data-v-39e5550d]{width:45%;margin-top:19.8%;margin-left:13.5%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-39e5550d","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/containers/section1/pages/Page6.vue
// module id = 83
// module chunks = 0